package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * A peer-to-peer marketplace listing (`marketplaceItems/{id}` — see `docs/DATA_MODEL.md`).
 * Metro-scoped; `status` transitions active → sold/removed (seller/admin only).
 */
data class MarketplaceItem(
    val id: String,
    val sellerUid: String,
    val sellerName: String,
    val title: String,
    val description: String,
    val priceCents: Long? = null,
    val isFree: Boolean = false,
    val condition: ItemCondition = ItemCondition.Used,
    /** Browse taxonomy (buyer-facing primary facet). Seller-chosen; defaults to Other. */
    val category: MarketplaceCategory = MarketplaceCategory.Other,
    val metroId: String? = null,
    val city: String = "",
    val photoUrls: List<String> = emptyList(),
    val status: ItemStatus = ItemStatus.Active,
    val createdAtMillis: Long? = null,
    /** Paid placement in the Marketplace "Featured" rail. Admin-set only (rules exclude it from
     * seller writes) — the monetization hook mirrors business sponsorships. */
    val featured: Boolean = false,
)

enum class ItemCondition { New, LikeNew, Used }
enum class ItemStatus { Active, Sold, Removed }

/**
 * Marketplace browse category (the primary facet buyers scan first, like Kijiji/FB Marketplace).
 * [wire] is the stable Firestore value; unknown/legacy docs decode to [Other].
 */
enum class MarketplaceCategory(val wire: String) {
    Furniture("furniture"),
    Electronics("electronics"),
    HomeKitchen("home_kitchen"),
    Appliances("appliances"),
    Clothing("clothing"),
    Kids("kids"),
    Books("books"),
    Vehicles("vehicles"),
    Sports("sports"),
    Other("other");

    companion object {
        fun fromWire(value: String?): MarketplaceCategory =
            entries.firstOrNull { it.wire == value } ?: Other
    }
}
